// extracted by mini-css-extract-plugin
export default {"container":"Oclock_container__alvYR","splitor":"Oclock_splitor__CJzOm","digit-container":"Oclock_digit-container__L1+sB","inner":"Oclock_inner__kgO9P","digit":"Oclock_digit__l2PhB"};